import type { FunctionComponent, PropsWithChildren } from 'react';
import styled from 'styled-components';
import useFitText from './FitText';

const Outer = styled.div`
	height: 100%;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
`;

const Content = styled.div`
	font-size: 1rem;
	max-height: 100%;
	max-width: 100%;
`;

interface Props {}

const AutofitText: FunctionComponent<Props> = (
	props: PropsWithChildren<Props>
) => {
	const { children } = props;
	const { fontSize, ref } = useFitText({
		minFontSize: 5,
		maxFontSize: 200,
		resolution: 5
	});

	return (
		<Outer>
			<Content ref={ref} style={{ fontSize }}>
				{children}
			</Content>
		</Outer>
	);
};

export default AutofitText;
